import { useId } from "react";

export const SelectField = ({ label, options, error, className, id, ...props }: any) => {
	const generatedId = useId();
	const fieldId = id || `select-${generatedId}`;
	return (
		<div className="space-y-1">
			<label htmlFor={fieldId} className="text-sm font-medium text-gray-300">
				{label}
			</label>
			<select
				id={fieldId}
				className={`w-full px-3 py-2 bg-brown rounded-md text-off-white focus:outline-none focus:ring-2 appearance-none transition-all ${
					error
						? "ring-2 ring-red-500/80 focus:ring-red-500/80"
						: "focus:ring-mgt-green"
				} ${className || ""}`}
				aria-invalid={error ? true : undefined}
				{...props}
			>
				<option value="" disabled>
					Choose an option
				</option>
				{options.map((option: string) => (
					<option key={option} value={option}>
						{option}
					</option>
				))}
			</select>
			{error ? (
				<p className="text-red-400 text-xs mt-0.5" role="alert">
					{error}
				</p>
			) : null}
		</div>
	);
};
